/* import __COLOCATED_TEMPLATE__ from './profile-deprecation-banner.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();